module.exports = __webpack_public_path__ + "static/media/logo.6d783f6f.png";